export default __webpack_public_path__ + "static/media/CivilEng_Shapes-06.7d23497c.png";